export var MARKER_CLICK = 'marker:click';
